const SelectDataButton = ({ active, children, ...props }) => (
  <button
    class="btn text-white block mr-2 mt-2"
    {...props}
    style={{ background: active ? "#7C3AED" : "#3B82F6" }}
  >
    {children}
  </button>
);

export const SelectInitialDataButtons = ({
  matches,
  onDefineData,
  onShowExample,
  onLoadPrevData,
  onShowUpload,
}) => {
  const previousDataDisabled =
    typeof window !== "undefined" ? !("indexedDB" in window) : null;

  return (
    <div class="define-data-card">
      <h1 class="h1 inline-block">Select Initial Data</h1>
      <p>
        Generate wind rose diagrams easily and intuitively online! Pick one
        these options to get started
      </p>
      <div class="flex flex-initial flex-wrap justify-between">
        <SelectDataButton
          title="First, determine your directions and bins, then enter the windrose data"
          onClick={onDefineData}
          active={matches("selectInitData.defineData")}
        >
          Define your own data
        </SelectDataButton>
        <SelectDataButton
          title="Just show an example to see how it works"
          onClick={onShowExample}
          active={matches("selectInitData.useExample")}
        >
          Show an example
        </SelectDataButton>
        <SelectDataButton
          title={
            previousDataDisabled
              ? "Not supported in your browser"
              : "If you've used this site before you can load data from previous visits"
          }
          onClick={onLoadPrevData}
          disabled={previousDataDisabled}
          active={matches("selectInitData.loadPrevious")}
        >
          Load previous data
        </SelectDataButton>
        <SelectDataButton
          title="Upload a csv file"
          onClick={onShowUpload}
          active={matches("selectInitData.uploadFile")}
        >
          From a csv file
        </SelectDataButton>
      </div>
    </div>
  );
};
